<template>
    <div>

        <b-alert show variant="info" class="p-1">
            <strong>NOTA:</strong> La Gratificación se activa en los meses de <strong>Julio</strong> y <strong>Diciembre</strong>, pero los formularios corresponden al ciclo del mes anterior (<strong>Junio</strong> y <strong>Noviembre</strong>). Por ello, los filtros de mes muestran los meses del ciclo de evaluación.
        </b-alert>

        <b-card no-body>
            <b-card-header>
                <h5 class="mb-0 text-white"><b>FILTROS</b></h5>
            </b-card-header>
            <b-card-body footer-tag="footer" class="pt-2">

                <b-row>

                    <b-col cols="12" md="4" class="mb-2">
                        <label for="year"><strong>AÑO</strong></label>
                        <v-select
                            id="year"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            v-model="filters.year"
                            :options="options.years"
                            :clearable="false"
                            class="w-100"
                        />
                    </b-col>

                    <b-col cols="12" md="4" class="mb-2">
                        <label for="month"><strong>MES</strong></label>
                        <v-select
                            id="month"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            v-model="filters.month"
                            :options="options.months"
                            :clearable="false"
                            class="w-100"
                        />
                    </b-col>

                    <b-col cols="12" md="4" class="mb-2">
                        <label for="providers"><strong>PROVEEDOR(ES)</strong></label>
                        <v-select
                            id="providers"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            v-model="filters.providers"
                            :options="options.providers"
                            class="w-100"
                            multiple
                        />
                    </b-col>

                </b-row>

            </b-card-body>

            <template #footer>

                <!-- BUTTON SUBMIT -->
                <b-button-loading
                    text="FILTRAR"
                    :processing="processing"
                    :block="true"
                    @process-action="getReportData">
                </b-button-loading>

            </template>

        </b-card>

        <b-card class="mb-0">

            <BButtonDownloadExcel
                :data="downloadExcelData()"
                :name="getExcelFileName()"
            />

            <b-table
                ref="table"
                striped
                hover
                responsive
                class="position-relative text-center mb-0"
                :per-page="perPage"
                :current-page="currentPage"
                :items="items"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                show-empty
                :busy="processing"
                empty-text="NO SE ENCONTRARON REGISTROS COINCIDENTES"
            >

                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle mb-1"></b-spinner>
                        <div><b>CARGANDO</b></div>
                    </div>
                </template>

                <template #cell(index)="data">
                    <span class="text-muted">{{ data.index + 1 }}</span>
                </template>

                <template #head(month)="data">
					<span v-html="data.label"></span>
				</template>

                <template #cell(month)="data">
                    <b-badge
                        v-if="data.item.locked"
                        variant="light-secondary"
                    >
                        <feather-icon icon="LockIcon" />
                        {{ data.item.month }}
                    </b-badge>
                    <b-badge
                        v-else
                        variant="light-info"
                    >{{ data.item.month }}</b-badge>
                </template>

                <template #cell(carta_magpe)="data">
                    <b-badge v-if="data.item.carta_magpe === null" variant="light-info">EXONERADO</b-badge>
                    <feather-icon v-else :icon="data.item.carta_magpe ? 'CheckCircleIcon' : 'XCircleIcon'" :class="data.item.carta_magpe ? 'text-success' : 'text-danger'" size="20" />
                </template>

                <template #cell(carta_hasp)="data">
                    <b-badge v-if="data.item.carta_hasp === null" variant="light-info">EXONERADO</b-badge>
                    <feather-icon v-else :icon="data.item.carta_hasp ? 'CheckCircleIcon' : 'XCircleIcon'" :class="data.item.carta_hasp ? 'text-success' : 'text-danger'" size="20" />
                </template>

                <template #cell(carta_antayafi)="data">
                    <b-badge v-if="data.item.carta_antayafi === null" variant="light-info">EXONERADO</b-badge>
                    <feather-icon v-else :icon="data.item.carta_antayafi ? 'CheckCircleIcon' : 'XCircleIcon'" :class="data.item.carta_antayafi ? 'text-success' : 'text-danger'" size="20" />
                </template>

                <template #cell(carta_hucomi)="data">
                    <b-badge v-if="data.item.carta_hucomi === null" variant="light-info">EXONERADO</b-badge>
                    <feather-icon v-else :icon="data.item.carta_hucomi ? 'CheckCircleIcon' : 'XCircleIcon'" :class="data.item.carta_hucomi ? 'text-success' : 'text-danger'" size="20" />
                </template>

                <template #cell(carta_cmr_golden)="data">
                    <b-badge v-if="data.item.carta_cmr_golden === null" variant="light-info">EXONERADO</b-badge>
                    <feather-icon v-else :icon="data.item.carta_cmr_golden ? 'CheckCircleIcon' : 'XCircleIcon'" :class="data.item.carta_cmr_golden ? 'text-success' : 'text-danger'" size="20" />
                </template>

                <template #cell(carta_inv_medicsalud)="data">
                    <b-badge v-if="data.item.carta_inv_medicsalud === null" variant="light-info">EXONERADO</b-badge>
                    <feather-icon v-else :icon="data.item.carta_inv_medicsalud ? 'CheckCircleIcon' : 'XCircleIcon'" :class="data.item.carta_inv_medicsalud ? 'text-success' : 'text-danger'" size="20" />
                </template>

                <template #cell(carta_medicsalud)="data">
                    <b-badge v-if="data.item.carta_medicsalud === null" variant="light-info">EXONERADO</b-badge>
                    <feather-icon v-else :icon="data.item.carta_medicsalud ? 'CheckCircleIcon' : 'XCircleIcon'" :class="data.item.carta_medicsalud ? 'text-success' : 'text-danger'" size="20" />
                </template>

                <template #cell(carta_etefsa)="data">
                    <b-badge v-if="data.item.carta_etefsa === null" variant="light-info">EXONERADO</b-badge>
                    <b-badge v-else-if="data.item.carta_etefsa === 'NA'" variant="light-secondary">N/A</b-badge>
                    <feather-icon v-else :icon="data.item.carta_etefsa ? 'CheckCircleIcon' : 'XCircleIcon'" :class="data.item.carta_etefsa ? 'text-success' : 'text-danger'" size="20" />
                </template>

            </b-table>

        </b-card>

    </div>
</template>

<script>

    import BButtonDownloadExcel from '@core/components/b-button-download-excel/BButtonDownloadExcel.vue';
    import BButtonLoading from '@core/components/b-button-loading/BButtonLoading.vue';
    import { ref, onBeforeMount } from '@vue/composition-api';
    import vSelect from 'vue-select';
    import moment from 'moment';
    import axios from '@axios';

    export default {
        components: {
            BButtonDownloadExcel,
            BButtonLoading,

            vSelect
        },
        setup() {

            // REFS
            const processing = ref(false);
            const options = ref({});

            const filters = ref({
                year: null,
                month: null,
                providers: []
            });

            const perPage = ref(50000);
            const totalRows = ref(1);
            const currentPage = ref(1);

            const sortBy = ref('');
            const sortDesc = ref(false);
            const sortDirection = ref('asc');
            const filter = ref(null);
            const filterOn = ref([]);
            const fields = ref(
                [
                    {
                        key: 'index',
                        label: '#',
                        sortable: false,
                        thStyle: { width: '50px' }
                    },
                    {
                        key: 'month',
                        label: 'MES/AÑO <br> EVALUACIÓN',
                        sortable: false
                    },
                    {
                        key: 'proveedor',
                        label: 'PROVEEDOR',
                        sortable: false
                    },
                    {
                        key: 'carta_magpe',
                        label: 'MAGPE',
                        sortable: false
                    },
                    {
                        key: 'carta_hasp',
                        label: 'HASP',
                        sortable: false
                    },
                    {
                        key: 'carta_antayafi',
                        label: 'ANTAYAFI',
                        sortable: false
                    },
                    {
                        key: 'carta_hucomi',
                        label: 'HUCOMI',
                        sortable: false
                    },
                    {
                        key: 'carta_cmr_golden',
                        label: 'CMR GOLDEN',
                        sortable: false
                    },
                    {
                        key: 'carta_inv_medicsalud',
                        label: 'INV. MEDICSALUD',
                        sortable: false
                    },
                    {
                        key: 'carta_medicsalud',
                        label: 'MEDICSALUD',
                        sortable: false
                    },
                    {
                        key: 'carta_etefsa',
                        label: 'ETEFSA',
                        sortable: false
                    },
                    {
                        key: 'evidence_comment',
                        label: 'COMENTARIO',
                        sortable: false
                    }
                ]
            );
            const items = ref([]);

            // CALL FUNCTION TO POPULATE OPTIONS FOR THE FILTERS
            onBeforeMount( async () => {
                await getSelectFilters();
                await setData();
                await getReportData();
            });

            const getSelectFilters = async () => {
                const { data } = await axios.get('/reports/gratification-cartas/filters');
                options.value = data.data;
            };

            const setData = async () => {

                const currentYear = parseInt(moment().subtract(1, 'months').format('YYYY'));
                const currentMonth = parseInt(moment().subtract(1, 'months').format('MM'));

                filters.value.year = options.value.years.find(year => year.id === currentYear);

                // Select the most recent available month
                const availableMonths = options.value.months.map(m => m.id);
                let selectedMonth = null;

                for (let i = availableMonths.length - 1; i >= 0; i--) {
                    if (availableMonths[i] <= currentMonth) {
                        selectedMonth = availableMonths[i];
                        break;
                    }
                }

                if (!selectedMonth) {
                    selectedMonth = availableMonths[availableMonths.length - 1];
                }

                filters.value.month = options.value.months.find(month => month.id === selectedMonth);

            };

            const getReportData = async () => {

                processing.value = true;

                const year = filters.value.year.id;
                const month = filters.value.month.id;

                const providers = filters.value.providers ? filters.value.providers.map(item => item.value) : [];

                const { data } = await axios.get(`/reports/gratification-cartas?year=${year}&month=${month}&providers=${providers.join(',')}`);

                items.value = data.data;
                perPage.value = data.data.length;
                totalRows.value = data.data.length;

                processing.value = false;

            };

            const onFiltered = (filteredItems) => {
                totalRows.value = filteredItems.length;
                currentPage.value = 1;
            };

            const getExcelFileName = () => {
                let fileName = 'reporte_gratificacion_cartas_no_adeudos.xls';

                if (filters.value.month && filters.value.year)
                {
                    fileName = `reporte_gratificacion_cartas_no_adeudos_${filters.value.month.label.toLowerCase()}_${filters.value.year.label}.xls`;
                }

                return fileName;
            };

            const downloadExcelData = () => {

                let data = [];

                for (let a = 0; a < items.value.length; a++)
                {
                    const cartaValue = (val) => val === null ? 'EXONERADO' : (val === 'NA' ? 'N/A' : (val ? 'SÍ' : 'NO'));

                    let object = {
                        'ITEM': (a + 1),
                        'MES/AÑO EVALUACIÓN': items.value[a]['month'],
                        'PROVEEDOR': items.value[a]['proveedor'],
                        'CARTA NO ADEUDO MAGPE': cartaValue(items.value[a]['carta_magpe']),
                        'CARTA NO ADEUDO HASP': cartaValue(items.value[a]['carta_hasp']),
                        'CARTA NO ADEUDO ANTAYAFI': cartaValue(items.value[a]['carta_antayafi']),
                        'CARTA NO ADEUDO HUCOMI': cartaValue(items.value[a]['carta_hucomi']),
                        'CARTA NO ADEUDO CMR GOLDEN': cartaValue(items.value[a]['carta_cmr_golden']),
                        'CARTA NO ADEUDO INV MEDICSALUD': cartaValue(items.value[a]['carta_inv_medicsalud']),
                        'CARTA NO ADEUDO MEDICSALUD': cartaValue(items.value[a]['carta_medicsalud']),
                        'CARTA NO ADEUDO ETEFSA': cartaValue(items.value[a]['carta_etefsa']),
                        'COMENTARIO': items.value[a]['evidence_comment'] || ''
                    };

                    data.push(object);
                }

                return data;

            };

            return {
                // TABLE DATA
                perPage,
                totalRows,
                currentPage,

                sortBy,
                sortDesc,
                sortDirection,
                filter,
                filterOn,
                fields,
                items,

                // DATA
                processing,
                filters,
                options,

                // METHODS
                getReportData,
                onFiltered,
                getExcelFileName,
                downloadExcelData
            }
        }
    }

</script>

<style lang="scss" scoped>

    .card-header {
        background-color: var(--primary);
        padding: 1rem 1.5rem;
    }

</style>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
